import { numberToUSD } from "../../../../utils"
import Cell from "../../../billing-table/cell"

interface Props {
  subTotal: number
}

const TableFooter = ({ subTotal }: Props) => (
  <tfoot>
    <tr>
      <Cell colSpan={4} className="text-right border-t border-zinc-200">
        <span className="text-sm font-medium uppercase">sub total</span>
        <strong className="inline-block pl-4 text-lg font-extrabold">
          {numberToUSD(subTotal)}
        </strong>
      </Cell>
    </tr>
  </tfoot>
)

export default TableFooter
